var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link c-btn__menu",on:{"click":function($event){return _vm.updateMenuStatus()}}},[_c('i',{staticClass:"c-btn__menu__icon loi-icon-menu"})])}
var staticRenderFns = []

export { render, staticRenderFns }